<template>
  <div>
    <simpletoolbar />
    <main class="max-w-3xl mx-auto px-4 py-10">

      <!-- Post not found -->
      <div v-if="!post" class="text-center py-20 text-stone-500 dark:text-stone-400">
        <p class="text-2xl mb-4">Post not found</p>
        <router-link to="/blog" class="text-primary-600 dark:text-primary-400 hover:underline">
          ← Back to Blog
        </router-link>
      </div>

      <!-- Post content -->
      <article v-else>
        <router-link
          to="/blog"
          class="text-sm text-primary-600 dark:text-primary-400 hover:underline mb-6 inline-block"
        >
          ← Back to Blog
        </router-link>

        <h1 class="text-3xl font-bold text-stone-800 dark:text-stone-100 mt-4 mb-3 leading-tight">
          {{ post.title }}
        </h1>

        <p class="text-sm text-stone-400 dark:text-stone-500 mb-8">
          {{ formatDate(post.date) }}
        </p>

        <!-- Rendered markdown -->
        <div
          class="prose prose-stone dark:prose-invert max-w-none"
          v-html="post.html"
        />

        <!-- Footer CTA -->
        <div class="mt-12 pt-8 border-t border-stone-200 dark:border-stone-700 text-center">
          <p class="text-stone-600 dark:text-stone-300 mb-4">
            Ready to give it a spin?
          </p>
          <router-link
            to="/"
            class="inline-block bg-primary-600 hover:bg-primary-700 dark:hover:bg-primary-800 text-white dark:text-white font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            Try Spin the Names Free →
          </router-link>
        </div>
      </article>

    </main>
    <app-footer />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import simpletoolbar from '@components/ui/simpletoolbar.vue';
import appFooter from '@components/ui/appFooter.vue';
import { useSeo } from '@/composables/useSeo';
import { getPost } from '@utils/BlogLoader.js';

const route = useRoute();

const post = computed(() =>
  getPost(route.params.year, route.params.slug)
);

useSeo({
  title: () => post.value ? `${post.value.title} | Spin the Names` : 'Blog | Spin the Names',
  description: () => post.value?.description || '',
  structuredData: () => {
    if (!post.value) return null;
    return {
      '@context': 'https://schema.org',
      '@type': 'BlogPosting',
      headline: post.value.title,
      description: post.value.description,
      datePublished: post.value.date,
      dateModified: post.value.date,
      author: {
        '@type': 'Organization',
        name: 'Spin the Names',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Spin the Names',
        logo: {
          '@type': 'ImageObject',
          url: 'https://spinthenames.com/logo.png',
        },
      },
      url: `https://spinthenames.com${post.value.path}`,
    };
  },
});

function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}
</script>
